"use strict";
var base = require("./base");

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
  $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}

module.exports = {
  methods: {
    updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
  },

  availability: base.availability,

  addToCart: base.addToCart,

  updateAttributesAndDetails: function () {
    $("body").on("product:statusUpdate", function (e, data) {
      var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

      $productContainer
        .find(".description-and-detail .product-attributes")
        .empty()
        .html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer
          .find(".description-and-detail .description")
          .removeClass("hidden-xl-down");
        $productContainer
          .find(".description-and-detail .description .content")
          .empty()
          .html(data.shortDescription);
      } else {
        $productContainer
          .find(".description-and-detail .description")
          .addClass("hidden-xl-down");
      }

      if (data.longDescription) {
        $productContainer
          .find(".description-and-detail .details")
          .removeClass("hidden-xl-down");
        $productContainer
          .find(".description-and-detail .details .content")
          .empty()
          .html(data.longDescription);
      } else {
        $productContainer
          .find(".description-and-detail .details")
          .addClass("hidden-xl-down");
      }
    });
  },

  showSpinner: function () {
    $("body").on(
      "product:beforeAddToCart product:beforeAttributeSelect",
      function () {
        $.spinner().start();
      }
    );
  },
  updateAttribute: function () {
    $("body").on("product:afterAttributeSelect", function (e, response) {
      if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0).length) {
        response.container.data("pid", response.data.product.id);
        response.container.find(".product-id").text(response.data.product.id);
      } else {
        $(".product-id").text(response.data.product.id);
        $('.product-detail:not(".bundle-item")').data(
          "pid",
          response.data.product.id
        );
      }
    });
  },
  updateAddToCart: function () {
    $("body").on("product:updateAddToCart", function (e, response) {
      const $addToCartBtn = $("button.add-to-cart", response.$productContainer);
      // update local add to cart (for sets)

      const isProductAvailable =
        (response.product.readyToOrder &&
          response.product.available &&
          response.product.eligible &&
          !response.product.isPastRegistrationDate &&
          !response.product.isPastDate) ||
        (response.product.readyToOrder &&
          response.product.available &&
          response.product.eligible &&
          (response.product.isPastRegistrationDate || response.product.isPastDate) &&
          response.product.isAllowedForCurrentCustomer
        );

      $addToCartBtn.attr("disabled", !isProductAvailable);

      const availableMsg = $addToCartBtn.data("available-msg");
      const unavailableMsg = $addToCartBtn.data("unavailable-msg");
      $addToCartBtn.text(isProductAvailable ? availableMsg : unavailableMsg);

      var enable = $(".product-availability")
        .toArray()
        .every(function (item) {
          return $(item).data("available") && $(item).data("ready-to-order");
        });
      module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
    });
  },
  updateAvailability: function () {
    $("body").on("product:updateAvailability", function (e, response) {
      $("div.availability", response.$productContainer)
        .data("ready-to-order", response.product.readyToOrder)
        .data("available", response.product.available);

      $(".availability-msg", response.$productContainer)
        .empty()
        .html(response.message);

      if ($(".global-availability").length) {
        var allAvailable = $(".product-availability")
          .toArray()
          .every(function (item) {
            return $(item).data("available");
          });

        var allReady = $(".product-availability")
          .toArray()
          .every(function (item) {
            return $(item).data("ready-to-order");
          });

        $(".global-availability")
          .data("ready-to-order", allReady)
          .data("available", allAvailable);

        $(".global-availability .availability-msg")
          .empty()
          .html(
            allReady ? response.message : response.resources.info_selectforstock
          );
      }
    });
  },
  sizeChart: function () {
    $(".size-chart a").on("click", function (e) {
      e.preventDefault();
      var url = $(this).attr("href");
      var $prodSizeChart = $(this)
        .closest(".size-chart")
        .find(".size-chart-collapsible");
      if ($prodSizeChart.is(":empty")) {
        $.ajax({
          url: url,
          type: "get",
          dataType: "json",
          success: function (data) {
            $prodSizeChart.append(data.content);
          },
        });
      }
      $prodSizeChart.toggleClass("active");
    });

    var $sizeChart = $(".size-chart-collapsible");
    $("body").on("click touchstart", function (e) {
      if ($(".size-chart").has(e.target).length <= 0) {
        $sizeChart.removeClass("active");
      }
    });
  },
  copyProductLink: function () {
    $("body").on("click", "#fa-link", function () {
      event.preventDefault();
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val($("#shareUrl").val()).select();
      document.execCommand("copy");
      $temp.remove();
      $(".copy-link-message").attr("role", "alert");
      $(".copy-link-message").removeClass("d-none");
      setTimeout(function () {
        $(".copy-link-message").addClass("d-none");
      }, 3000);
    });
  },
  flashAddToCart: function () {
    const $productDetailContainer = $('div.product-detail');
    const isProductAddedToCart = $productDetailContainer.data('added');
    const addToCartMessage = $productDetailContainer.data('add-cart-message');
    if (isProductAddedToCart || (!isProductAddedToCart && addToCartMessage)) {
      base.handlePostCartAdd({
        error: !isProductAddedToCart,
        message: addToCartMessage
      })
    }
  },

  focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
  selectAttribute: base.selectAttribute,
};